module.exports = __webpack_public_path__ + "a92eecf150c4f76c6d6743f34dd32bf0.png";